module.exports = __webpack_public_path__ + "@/assets/img/cpu.7be18364.svg";